import { createSlice } from "@reduxjs/toolkit";

export const profileSlice = createSlice({
    name: 'profile',
    initialState: {
        value: undefined
    },
    reducers: {
        setProfile: (state, action) => {
            state.value = action.payload;
        }
    }
})

export const { setProfile } = profileSlice.actions;

export const getProfile = (state) => state.profile.value;

export default profileSlice.reducer;